
// FA Header Cart Count (#240 follow-up): the theme's vendor cart ajax script only
// shows/hides [data-cart-count], it never writes the number. This vanilla helper watches
// for any add/change/update/clear request (whether the theme issued it via XHR or fetch)
// and, once it resolves successfully, fetches /cart.js itself for the real item_count -
// the add endpoint's own response is just the added line item, not the full cart, so it
// can't be read directly. A short debounce collapses a burst of mutations (e.g. quantity
// steppers) into one refetch. Idempotency-guarded so this never installs twice, and the
// module's own /cart.js call is excluded from the watch (and made via the captured native
// fetch) so it can't re-trigger itself.
(function () {
  if (window.__faCartBadgePatched) return;
  window.__faCartBadgePatched = true;

  var cartMutationEndpoint = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var nativeFetch = window.fetch ? window.fetch.bind(window) : null;
  var refetchTimer = null;

  function updateCartBadge(count) {
    var label = count === 1 ? 'Cart, 1 item' : count > 0 ? 'Cart, ' + count + ' items' : 'Cart';
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count > 9 ? '9+' : String(count);
      el.style.display = count > 0 ? '' : 'none';
      var link = el.closest('a.cart-icon');
      if (link) link.setAttribute('aria-label', label);
    });
  }

  function isPlainCartJs(url) {
    try {
      var pathname = new URL(url, window.location.origin).pathname;
      return pathname === '/cart.js';
    } catch (e) {
      return false;
    }
  }

  function isCartMutation(url) {
    return typeof url === 'string' && cartMutationEndpoint.test(url) && !isPlainCartJs(url);
  }

  // Debounced: a burst of mutation calls (e.g. two quick clicks) triggers one refetch.
  function scheduleCartRefetch() {
    if (!nativeFetch) return;
    if (refetchTimer) clearTimeout(refetchTimer);
    refetchTimer = setTimeout(function () {
      refetchTimer = null;
      nativeFetch('/cart.js', { credentials: 'same-origin' })
        .then(function (response) {
          return response.ok ? response.json() : null;
        })
        .then(function (data) {
          if (data && typeof data.item_count === 'number') updateCartBadge(data.item_count);
        })
        .catch(function () {
          // network hiccup - the next successful mutation will refetch again
        });
    }, 120);
  }

  var openXHR = XMLHttpRequest.prototype.open;
  var sendXHR = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._faCartUrl = url;
    return openXHR.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (isCartMutation(this._faCartUrl)) {
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) scheduleCartRefetch();
      });
    }
    return sendXHR.apply(this, arguments);
  };

  if (nativeFetch) {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : input && input.url;
      var promise = nativeFetch(input, init);
      if (isCartMutation(url)) {
        promise
          .then(function (response) {
            // .ok doesn't touch the body, so the clone the caller receives (via the
            // untouched `promise` returned below) is still safe to read once, in full.
            var clone = response.clone();
            if (clone.ok) scheduleCartRefetch();
          })
          .catch(function () {});
      }
      return promise;
    };
  }
})();

jQuery(document).ready(function(){
  jQuery("#FiltersForm2 .yv-filter-item .lnk-wrapper .expand").on("click", function () {
    jQuery(this).parents(".yv-filter-item").find("ul").toggleClass("active");
    jQuery(this).find("span").toggle();
  })
  jQuery("#FiltersForm2 .yv-filter-item .lnk-wrapper ul .active").parent("ul").show()
  if (jQuery(window).width() <= 767)
  {
    jQuery(".list-menu__item.toggle").click();
    }

})
jQuery(document).ready(function(){
  if($('.sort-select select').length){
    $('.sort-select select').on('change',function(){
      let selectedValue = $(this).val()
      $('#sort__list input[value="'+selectedValue+'"').next().trigger('click');
    });  
  }
  if($('.filter-accodian-title').length){
    $('.filter-accodian-title').on('click',function(){
      $(this).toggleClass('active');
      $(this).next().slideToggle()
    });
  }
  if($('.submenublock').length > 0){
    $('.submenublock').on('click',function(){
      $(this).toggleClass('active');
      $(this).closest('.lnk-wrapper').next().slideToggle();
    });
  }
  if($('.productPer').length){
    $('.productPer').on('change',function(){
      let selectedValue = parseInt($(this).val());
      console.log(selectedValue)
      var formData = new FormData();
      formData.append("attributes[perpage]", selectedValue);
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => window.location.reload());
    })
  }
  if($('.total-review a').length){
    $('.total-review a').on('click',function(e){
      e.preventDefault();
      let SectionId = $(this).attr('href');
      console.log(SectionId)
      $('html, body').animate({
            scrollTop: $("#shopify-block-89022e43-91d2-436c-be2e-5fd21878637b").offset().top
        }, 2000);
    })  
  }
  
});

document.addEventListener("DOMContentLoaded", (event) => {
  let quantityBoxContainer = document.querySelector('.quantity-box');
  if(quantityBoxContainer){
    let quantityUp = quantityBoxContainer.querySelector('.uparrow');
    let quantityDown = quantityBoxContainer.querySelector('.downaerrow');
    let quntiyInput = quantityBoxContainer.querySelector('input');
    quantityUp.addEventListener('click',function(e){
      e.preventDefault()
      e.stopPropagation()
      let upValue =  parseInt(quntiyInput.value) + 1;
      quntiyInput.value = upValue;
    });
    quantityDown.addEventListener('click',function(e){
      e.preventDefault()
      e.stopPropagation()
      let downValue =  parseInt(quntiyInput.value) - 1;
      if(downValue == 0) return;
      quntiyInput.value = downValue;
    });
  }

  let youtubeList = document.querySelectorAll('.yt-image-column');
  let youtubeModal = document.querySelector('.yt-popup-modal');

  /* Bail out entirely when the pop-up isn't on the page, so the click
     handler below never fires and never leaves the page locked. */
  if(youtubeModal){
    let youtubeClose = youtubeModal.querySelector('.yt-close-btn');
    let youtubeWrapper = youtubeModal.querySelector('.youtube-frame-wrapper');
    let cartBar = youtubeModal.querySelector('[data-fa-yt-cart-bar]');
    let cartBarButton = cartBar ? cartBar.querySelector('[data-fa-yt-add-to-cart]') : null;
    let YT_PLAYER_ID = 'fa-yt-player';
    let ytApiLoadStarted = false;
    let ytPendingVideoId = null;
    let ytPlayer = null;
    let ytOpening = false;
    let ytReadyTimer = null;

    function clearYtReadyTimer(){
      if(ytReadyTimer){
        clearTimeout(ytReadyTimer);
        ytReadyTimer = null;
      }
    }


    /* Mirrors the real add-to-cart button's disabled state onto the modal's bar
       button, in case the shopper changed variant after the page first rendered. */
    function syncCartBarState(){
      if(!cartBarButton) return;
      let realButton = document.querySelector('.add_to_cart.button');
      if(!realButton) return;
      cartBarButton.disabled = !!realButton.disabled;
    }

    if(cartBarButton){
      cartBarButton.addEventListener('click', function(){
        if(cartBarButton.disabled) return;
        let realButton = document.querySelector('.add_to_cart.button');
        if(realButton && !realButton.disabled){
          realButton.click();
        }
        closeYoutubeModal();
      });
    }

    /* Product videos are reels: every URL format (watch, youtu.be, shorts) plays as a
       vertical 9:16 player (#248), so the parsed id is all the caller needs. */
    function getYoutubeEmbed(rawUrl){
      if(!rawUrl) return null;
      let cleanUrl = rawUrl.split('?')[0].split('#')[0];
      let id = null;
      let shortsMatch = cleanUrl.match(/youtube\.com\/shorts\/([A-Za-z0-9_-]{11})/i);
      let youtuBeMatch = cleanUrl.match(/youtu\.be\/([A-Za-z0-9_-]{11})/i);
      let watchMatch = rawUrl.match(/[?&]v=([A-Za-z0-9_-]{11})/i);
      if(shortsMatch){
        id = shortsMatch[1];
      } else if(youtuBeMatch){
        id = youtuBeMatch[1];
      } else if(watchMatch){
        id = watchMatch[1];
      }
      if(!id) return null;
      return { videoId: id };
    }

    /* The IFrame API replaces the target element with its own <iframe> (reusing the
       same id), so a fresh placeholder has to be re-created after destroy() before
       the player can be built again. */
    function ensurePlayerContainer(){
      if(!youtubeWrapper) return null;
      let existing = document.getElementById(YT_PLAYER_ID);
      if(existing) return existing;
      let container = document.createElement('div');
      container.id = YT_PLAYER_ID;
      youtubeWrapper.insertBefore(container, youtubeWrapper.firstChild);
      return container;
    }

    function createYoutubePlayer(videoId){
      let container = ensurePlayerContainer();
      if(!container || typeof YT === 'undefined' || !YT.Player) return;
      ytPlayer = new YT.Player(container.id, {
        videoId: videoId,
        playerVars: { autoplay: 1, playsinline: 1, rel: 0 },
        events: {
          onReady: function(event){
            clearYtReadyTimer();
            /* The modal may have been closed while the player was loading - never
               leave a stray player autoplaying behind a closed modal (PR #252
               review). */
            if(!youtubeModal.classList.contains('open')){
              try { event.target.destroy(); } catch(err){ /* already gone */ }
              if(ytPlayer === event.target) ytPlayer = null;
              ensurePlayerContainer();
              return;
            }
            try { event.target.playVideo(); } catch(err){ /* ignore */ }
            /* Some browsers block autoplay with sound even after a click that
               opened the modal - fall back to a muted autoplay so the video
               always starts. */
            setTimeout(function(){
              if(!youtubeModal.classList.contains('open')) return;
              try {
                let state = event.target.getPlayerState();
                if(state !== YT.PlayerState.PLAYING && state !== YT.PlayerState.BUFFERING){
                  event.target.mute();
                  event.target.playVideo();
                }
              } catch(err){ /* player may have been torn down */ }
            }, 1200);
          }
        }
      });
    }

    function loadYoutubeIframeApi(){
      if(ytApiLoadStarted) return;
      ytApiLoadStarted = true;
      let previousReady = window.onYouTubeIframeAPIReady;
      window.onYouTubeIframeAPIReady = function(){
        if(typeof previousReady === 'function') previousReady();
        /* Only build the player if a video is still pending AND the modal is
           still open - closing before the API finished loading must not leave
           a stray player behind (PR #252 review). */
        if(youtubeModal.classList.contains('open') && ytPendingVideoId){
          let videoId = ytPendingVideoId;
          ytPendingVideoId = null;
          createYoutubePlayer(videoId);
        } else {
          ytPendingVideoId = null;
        }
      };
      let tag = document.createElement('script');
      tag.onerror = function(){
        ytPendingVideoId = null;
        if(youtubeModal.classList.contains('open')){
          closeYoutubeModal();
        }
      };
      tag.src = 'https://www.youtube.com/iframe_api';
      document.head.appendChild(tag);
    }

    function closeYoutubeModal(){
      clearYtReadyTimer();
      ytPendingVideoId = null;
      try {
        youtubeModal.classList.remove('open');
        if(youtubeWrapper) youtubeWrapper.classList.remove('fa-yt-vertical');
        if(ytPlayer){
          try {
            if(typeof ytPlayer.stopVideo === 'function') ytPlayer.stopVideo();
            if(typeof ytPlayer.destroy === 'function') ytPlayer.destroy();
          } catch(err){ /* player may already be torn down */ }
          ytPlayer = null;
        }
        ensurePlayerContainer();
      } finally {
        /* The video must never trap the shopper on the page - scroll is always
           restored, whatever else above throws (owner rule, #248). */
        document.body.classList.remove('overflow-hidden');
        ytOpening = false;
      }
    }

    if(youtubeClose){
      youtubeClose.addEventListener('click', closeYoutubeModal);
    }

    /* Backdrop click: only when the click lands on the modal itself, not the inner box */
    youtubeModal.addEventListener('click', function(e){
      if(e.target === youtubeModal){
        closeYoutubeModal();
      }
    });

    document.addEventListener('keydown', function(e){
      if(e.key === 'Escape' && youtubeModal.classList.contains('open')){
        closeYoutubeModal();
      }
    });

    if(youtubeList){
      youtubeList.forEach(function(player){
        function openYoutubeModal(){
          if(ytOpening || !youtubeModal) return;
          let dataYoutubelink = player.getAttribute('data-video-link');
          let embed = getYoutubeEmbed(dataYoutubelink);
          if(!embed || !youtubeWrapper) return;
          ytOpening = true;

          try {
            youtubeWrapper.classList.add('loading');
            /* Every product video plays as a vertical 9:16 reel (#248) */
            youtubeWrapper.classList.add('fa-yt-vertical');
            youtubeModal.classList.add('open');
            /* Lock scroll only now that the modal has actually opened */
            document.body.classList.add('overflow-hidden');
            if(youtubeClose) youtubeClose.focus();
            syncCartBarState();

            if(typeof YT !== 'undefined' && YT.Player){
              createYoutubePlayer(embed.videoId);
            } else {
              ytPendingVideoId = embed.videoId;
              loadYoutubeIframeApi();
            }

            /* Never trap the shopper behind a video that won't load: if the
               player hasn't reached READY within ~6s, close the modal and
               offer the video on YouTube directly instead (owner rule, #248). */
            clearYtReadyTimer();
            ytReadyTimer = setTimeout(function(){
              ytReadyTimer = null;
              if(youtubeModal.classList.contains('open')){
                closeYoutubeModal();
              }
            }, 6000);
          } catch(err){
            /* Any failure here must still leave the page scrollable. */
            closeYoutubeModal();
            return;
          }

          setTimeout(function(){
            youtubeWrapper.classList.remove('loading');
            ytOpening = false;
          },1000);
        }

        player.addEventListener('click', openYoutubeModal);
        player.addEventListener('keydown', function(e){
          if(e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar'){
            e.preventDefault();
            openYoutubeModal();
          }
        });
      })
    }
  }

  
});
function debounce(func, delay = 5000) {
  let timeoutId

  return function(...arguments) {
    console.log("function called")
    clearTimeout(timeoutId)

    timeoutId = setTimeout(() => {
      func(...arguments)
    }, delay)
  }
}
function resizeThumbSlider(){
    if($('.yv-product-slider-wrapper').hasClass('custom-slider')){
      let maxHeight = $('.custom-slider .data-main-slider').height()
      
      $('.custom-slider .yv-product-gallery-thumbs').css('max-height',maxHeight+'px');
    }
}
$(document).ready(function(){
   $(window).resize(function(){
     if($(window).width() > 767){
        if($('.yv-product-slider-wrapper').hasClass('custom-slider')){
           resizeThumbSlider();
        }
     }
  });

  if($(window).width() > 767){
    
  if($('.yv-product-slider-wrapper').hasClass('custom-slider')){
    resizeThumbSlider()
   $('.gallery-thumbs-item').on('click',function(){
     const sliderIndex = parseInt($(this).attr('data-index'));
     $('.gallery-thumbs-item').removeClass('active');
     $(this).addClass('active');
      productSlider.select(sliderIndex)
   });
    let Interval = setInterval(function(){
      console.log(typeof productSlider)
      if(typeof productSlider == 'object'){
        productSlider.on('change',function(index){
          $('.gallery-thumbs-item').removeClass('active');
          $('.gallery-thumbs-item[data-index="'+index+'"]').addClass('active');
        });  
        clearInterval(Interval)
      }
    },500);
    setTimeout(function(){
      clearInterval(Interval)
    },6000)
    }
  }
    
  if($('.mobile-pr-sl-button').length){
    let sliderCount = $('.custom-with-slider .yv-product-slider .yv-product-slider-item').length - 1;
    
    let count = 0;
        const debounce = (func, delay) => {
            let debounceTimer
            return function () {
                const context = this
                const args = arguments
                clearTimeout(debounceTimer)
                debounceTimer
                    = setTimeout(() => func.apply(context, args), delay)
            }
        }
        $(".mobile-pr-sl-button").on('click', debounce(function () {
          
          let scrollPosition = $('.yv-product-slider').scrollLeft();
          let slideWidth = $('.custom-with-slider .yv-product-slider .yv-product-slider-item').width();
            if($(this).hasClass('next')){
              $('.custom-with-slider .yv-product-slider').scrollLeft(scrollPosition + slideWidth + 14)
            }
            else{
              
              $('.custom-with-slider .yv-product-slider').scrollLeft(scrollPosition - slideWidth - 14)
            }
            
        }, 300));
  }
})

// FA Add To Cart Failure (#407): the vendor handler in cart-ajax.min.js (a delegated click on
// .Sd_addProduct, used by the main button, the sticky bar button and quick view) adds
// is-loading to the button and only removes it inside its success and error callbacks. When the
// request gets no answer at all (dropped connection) its error callback reads
// responseJSON.description on an empty answer, throws, and never reaches the line that removes
// is-loading, so the spinner stays for ever. A request that hangs has no timeout either.
// This block leaves that file alone and watches only /cart/add requests (listeners added to the
// XHR, everything passed through untouched). On a failed or unanswered request (or after
// FA_ATC_TIMEOUT_MS) it restores the buttons and tells the shopper to try again; a late success
// clears the message again. Vanilla JS, installs once.
// The leading semicolon guards against the previous statement having no terminator.
;(function () {
  if (window.__faAtcFailurePatched) return;
  window.__faAtcFailurePatched = true;

  var FA_ATC_TIMEOUT_MS = 5000;
  // Upper bound for one add request: until then a second tap on the same form is swallowed
  // (the first request may still succeed, a second one would add two units); at this bound the
  // failure message shows and the shopper can tap again. Nothing is retried automatically.
  var FA_ATC_GIVE_UP_MS = 10000;
  var FA_ATC_MESSAGE = 'Could not add to cart. Please check your connection and try again.';
  var FA_ATC_PENDING = 'Still adding to cart. Please wait a moment...';
  var addUrl = /\/cart\/add(\.js)?(\?|$)/;
  var pendingForm = null;

  function loadingButtons() {
    return Array.prototype.slice.call(document.querySelectorAll('.Sd_addProduct.is-loading'));
  }

  function formOf(btn) {
    return btn.form || btn.closest('form');
  }

  // Monotonic clock (not affected by the device clock changing); falls back to Date.now().
  function now() {
    return window.performance && typeof window.performance.now === 'function' ? window.performance.now() : Date.now();
  }

  // True while the last add request of this form has no answer and is younger than the bound.
  function isOpen(form) {
    var open = form && form._faAtcOpen;
    return !!open && !open.settled && now() - open.t < FA_ATC_GIVE_UP_MS;
  }

  // The message boxes the vendor handler already uses (.productErrors): in the button's own
  // form (main button, quick view) and in the sticky bar.
  function messageBoxes(buttons) {
    var boxes = [];
    function add(list) {
      Array.prototype.forEach.call(list, function (el) {
        if (boxes.indexOf(el) === -1) boxes.push(el);
      });
    }
    buttons.forEach(function (btn) {
      var form = formOf(btn);
      if (form) add(form.querySelectorAll('.productErrors'));
      var bar = btn.closest('#yvProductStickyBar');
      if (bar) add(bar.querySelectorAll('.productErrors'));
    });
    return boxes;
  }

  function showMessage(buttons, text, cls, role) {
    messageBoxes(buttons).forEach(function (box) {
      // Shopify's own description (422 sold out or quantity limit) is already shown: keep it.
      // A message of ours (data-fa-atc) is replaced, so "still adding" turns into "could not".
      if (!box.hasAttribute('data-fa-atc') && box.style.display !== 'none' && box.textContent.trim()) return;
      box.setAttribute('role', role);
      box.setAttribute('data-fa-atc', '1');
      box.classList.remove('fa-atc-failed', 'fa-atc-pending');
      box.classList.add(cls);
      box.style.display = 'block';
      box.textContent = '';
      window.requestAnimationFrame(function () {
        box.textContent = text;
      });
    });
  }

  function showFailure(buttons) {
    buttons.forEach(function (btn) {
      btn.classList.remove('is-loading');
    });
    showMessage(buttons, FA_ATC_MESSAGE, 'fa-atc-failed', 'alert');
  }

  // No answer yet after FA_ATC_TIMEOUT_MS: say so, keep the spinner (the request is still open)
  // and let the form swallow taps until the request settles or FA_ATC_GIVE_UP_MS has passed.
  function showPending(buttons) {
    showMessage(buttons, FA_ATC_PENDING, 'fa-atc-pending', 'status');
  }

  function clearOwnMessages() {
    Array.prototype.forEach.call(document.querySelectorAll('.productErrors[data-fa-atc]'), function (box) {
      box.removeAttribute('data-fa-atc');
      box.classList.remove('fa-atc-failed', 'fa-atc-pending');
      box.textContent = '';
      box.style.display = 'none';
    });
  }

  // Runs before the vendor's delegated handler on body. Swallows a tap while this form's add
  // request is open; otherwise remembers the form so send() can link the request to it.
  document.addEventListener('click', function (e) {
    try {
      var btn = e.target && e.target.closest ? e.target.closest('.Sd_addProduct') : null;
      if (!btn) return;
      var form = formOf(btn);
      if (isOpen(form)) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return;
      }
      pendingForm = form;
      setTimeout(function () {
        pendingForm = null;
      }, 0);
    } catch (err) {
      pendingForm = null;
    }
  }, true);

  var openXHR = XMLHttpRequest.prototype.open;
  var sendXHR = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._faAtcUrl = url;
    return openXHR.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    var entry = null;
    if (typeof this._faAtcUrl === 'string' && addUrl.test(this._faAtcUrl)) {
      try {
        var xhr = this;
        var done = false;
        entry = { t: now(), settled: false };
        if (pendingForm) pendingForm._faAtcOpen = entry;
        pendingForm = null;
        var watchdog = setTimeout(function () {
          if (!done) showPending(loadingButtons());
        }, window.FA_ATC_TIMEOUT_MS || FA_ATC_TIMEOUT_MS);
        var hardStop = setTimeout(function () {
          if (!done) showFailure(loadingButtons());
        }, FA_ATC_GIVE_UP_MS);
        xhr.addEventListener('loadend', function () {
          done = true;
          entry.settled = true;
          clearTimeout(watchdog);
          clearTimeout(hardStop);
          // After the vendor callbacks have run. A late success lands here too: the vendor
          // success callback has already opened the drawer and rebuilt the cart, so only our
          // message needs to go.
          setTimeout(function () {
            if (xhr.status >= 200 && xhr.status < 300) clearOwnMessages();
            else showFailure(loadingButtons());
          }, 0);
        });
      } catch (err) {
        // Never block the request or the button because of this watcher.
      }
    }
    try {
      return sendXHR.apply(this, arguments);
    } catch (err) {
      // send() threw: no request is open, so a wrong "still adding" must not show.
      if (entry) entry.settled = true;
      throw err;
    }
  };
})();

/* ===== FA Add To Cart Price (#414) =====
   The Liquid prints "<cart icon> Add to cart - Rs. X" on first load. When the shopper picks another
   variant, common.min.js overwrites the label with the plain translated "Add to cart" (no icon,
   no price). Re-apply the Liquid's wording with the chosen variant's price right after that write.
   Sold out, unavailable and pre-order labels are left to the theme. Vanilla JS, no loop: our own
   write is no longer the plain label, and the records it makes are discarded. */
(function () {
  'use strict';

  function plainLabel() {
    return typeof addToCartText === 'string' ? addToCartText.trim() : '';
  }

  function variantPrice(button) {
    var form = button.closest('form');
    var input = form && form.querySelector('[name="id"]');
    var scope = button.closest('.shopify-section') || document;
    var json = scope.querySelector('[data-name="variant-json"]');
    if (!input || !json) return null;
    try {
      var list = JSON.parse(json.textContent);
      for (var i = 0; i < list.length; i++) {
        if (String(list[i].id) === String(input.value)) return list[i].price;
      }
    } catch (e) {
      return null;
    }
    return null;
  }

  function repair(button, observer) {
    var span = button.querySelector('.addCartText');
    var label = plainLabel();
    // Only the theme's plain write: text equals "Add to cart" and no icon. Anything else (price
    // already there, Sold out, Unavailable, Pre-order) is left alone.
    if (!span || !label || span.querySelector('svg') || span.textContent.trim() !== label) return;
    var price = variantPrice(button);
    var format = button.getAttribute('data-fa-money-format');
    if (price === null || !format || !window.Shopify || typeof window.Shopify.formatMoney !== 'function') return;
    var icon = button.querySelector('template[data-fa-atc-icon]');
    span.innerHTML = (icon ? icon.innerHTML : '') + ' ' + label + ' - ' + window.Shopify.formatMoney(price, format);
    observer.takeRecords();
  }

  function watch(button) {
    if (button.faAtcPriceWatched) return;
    button.faAtcPriceWatched = true;
    var observer = new MutationObserver(function () {
      repair(button, observer);
    });
    observer.observe(button, { childList: true, subtree: true, characterData: true });
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('.Sd_addProduct[data-fa-atc-price]'), watch);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

// FA WhatsApp widget (#459): the Aisensy button rests in the bottom corner and lifts to 12px above the top
// edge of any Add to cart area that reaches that corner (the sticky bar when it shows, the in-page Add to
// cart / Buy now buttons while scrolling). The lift is published as --fa-wa-lift (px, 0 when none) and the
// class fa-wa-js on <html> tells assets/custom-style.css to use it; without this script the CSS fallback
// keeps the button above the tallest bar. ES5 only (old Android WebViews): no arrow functions, let/const,
// template literals or optional chaining.
(function () {
  if (window.__faWaLift) return;
  window.__faWaLift = true;

  var AREAS = '#yvProductStickyBar, .add_to_cart, .shopify-payment-button__button';
  var GAP = 12;
  var BTN = 56;

  function shown(el) {
    var r = el.getBoundingClientRect();
    if (!(r.height > 0 && r.width > 0)) return false;
    var cs = window.getComputedStyle(el);
    if (cs.visibility === 'hidden' || cs.display === 'none') return false;
    // The sticky bar hides with opacity 0 (class "show" fades it in).
    var node = el;
    while (node && node.nodeType === 1) {
      if (parseFloat(window.getComputedStyle(node).opacity) < 0.05) return false;
      if (node === document.body) break;
      node = node.parentNode;
    }
    return true;
  }

  function init() {
    if (!/template_product/.test(document.body.className)) return;
    var root = document.documentElement;
    var queued = false;
    var lastLift = 0;
    // Real resting bottom = corner margin + the device safe-area inset (CSS: calc(16px + env(...))).
    // Read at start and again on resize/rotation, since the inset differs between portrait and landscape.
    var inset = 0;
    function readInset() {
      var probe = document.createElement('div');
      probe.style.cssText = 'position:absolute;visibility:hidden;pointer-events:none;padding-bottom:env(safe-area-inset-bottom,0px)';
      document.body.appendChild(probe);
      inset = parseFloat(window.getComputedStyle(probe).paddingBottom) || 0;
      document.body.removeChild(probe);
    }
    function onViewport() {
      readInset();
      schedule();
    }
    readInset();

    function compute() {
      queued = false;
      var vh = window.innerHeight;
      var corner = (window.matchMedia ? window.matchMedia('(min-width: 1025px)').matches : window.innerWidth >= 1025) ? 24 : 16;
      var rest = corner + inset;
      var lift = 0;
      var list = document.querySelectorAll(AREAS);
      // The sticky bar counts as soon as it has class "show" (clickable at once, even mid fade or slide-up):
      // use its resting height, not its current opacity or transform.
      var bar = document.getElementById('yvProductStickyBar');
      if (bar && /(^| )show( |$)/.test(bar.className) && bar.className.indexOf('sticky-atc-position-top') < 0 && bar.offsetHeight > 0 && bar.offsetHeight <= vh * 2 / 3) {
        lift = bar.offsetHeight + GAP;
      }
      // Lifting past one area can bring the next one into the button's way (Add to cart sits just above Buy now),
      // so repeat until nothing more reaches the button's current zone.
      for (var pass = 0; pass < 4; pass++) {
        var before = lift;
        var zoneTop = vh - Math.max(rest, lift) - BTN - GAP;
        for (var i = 0; i < list.length; i++) {
          var el = list[i];
          if (el === bar) continue;
          var r = el.getBoundingClientRect();
          // Only areas that reach the zone: not wholly above it, not below the screen, not a top bar.
          if (r.bottom <= zoneTop || r.top >= vh || r.top < vh / 3) continue;
          if (!shown(el)) continue;
          var need = vh - r.top + GAP;
          if (need > lift) lift = need;
        }
        if (lift === before) break;
      }
      lift = Math.round(lift);
      // Upward lifts apply instantly (class fa-wa-up turns the transition off); only the drop back animates.
      root.className = root.className.replace(/ fa-wa-up/g, '');
      if (lift > lastLift) root.className += ' fa-wa-up';
      lastLift = lift;
      root.style.setProperty('--fa-wa-lift', lift + 'px');
      // Final bottom as one plain px value, so the CSS needs no max()/env() (unsupported before Chrome 79/69).
      root.style.setProperty('--fa-wa-bottom-px', Math.max(corner + inset, lift) + 'px');
    }
    function schedule() {
      if (queued) return;
      queued = true;
      if (window.requestAnimationFrame) window.requestAnimationFrame(compute);
      else setTimeout(compute, 16);
    }

    root.className += ' fa-wa-js';
    compute();
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', onViewport);
    window.addEventListener('orientationchange', onViewport);
    window.addEventListener('load', schedule);
    var bar = document.getElementById('yvProductStickyBar');
    if (bar && window.MutationObserver) {
      new MutationObserver(compute).observe(bar, { attributes: true, attributeFilter: ['class', 'style'] });
    }
    if (bar && bar.addEventListener) {
      bar.addEventListener('transitionend', schedule);
      bar.addEventListener('transitionstart', schedule);
    }
    // Late changes: a Buy now injected after load, or the sticky bar changing height, recompute via the rAF schedule.
    var formBox = document.querySelector('.add_to_cart');
    formBox = (formBox && formBox.closest && formBox.closest('form')) || document.body;
    if (window.MutationObserver) {
      new MutationObserver(schedule).observe(formBox, { childList: true, subtree: true });
    }
    if (bar && window.ResizeObserver) {
      new window.ResizeObserver(schedule).observe(bar);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
